import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "testimonial-area pt-100" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "section-title text-center mw-860 m-auto mb-90" }
const _hoisted_4 = { class: "top-title" }
const _hoisted_5 = { class: "text-white" }
const _hoisted_6 = { class: "text-white" }
const _hoisted_7 = { class: "position-relative z-1" }
const _hoisted_8 = { class: "testimonial-single-item-two" }
const _hoisted_9 = { class: "d-flex align-items-center mb-32" }
const _hoisted_10 = { class: "flex-shrink-0" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "flex-grow-1 ms-4" }
const _hoisted_13 = { class: "ps-0 list-unstyled d-flex align-items-center gap-1" }
const _hoisted_14 = {
  key: 0,
  class: "text-center mt-5"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "border-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "testimonial-wrap bg-img pb-100",
        style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgImage})` })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.c.top_title), 1),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.c.title), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.c.description), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Swiper, {
            slidesPerView: 1,
            spaceBetween: 50,
            loop: true,
            autoplay: { delay: 2000, disableOnInteraction: false },
            navigation: { nextEl: '.next', prevEl: '.prev' },
            breakpoints: { 992: { slidesPerView: 2 }, 1440: { slidesPerView: 2 } },
            modules: _ctx.modules,
            class: "testomonial-slide-two"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.c.items, (t, index) => {
                return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("img", {
                            src: t.image_url || _ctx.fallbackAvatar,
                            alt: t.name
                          }, null, 8, _hoisted_11)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("ul", _hoisted_13, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                              return _createElementVNode("li", { key: star }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(star <= (t.rating || 5) ? 'ti ti-star-filled' : 'ti ti-star')
                                }, null, 2)
                              ])
                            }), 64))
                          ]),
                          _createElementVNode("h3", null, _toDisplayString(t.name), 1)
                        ])
                      ]),
                      _createElementVNode("p", null, _toDisplayString(t.review), 1)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["modules"]),
          _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"testomonial-controller\"><div class=\"controller-icon prev\"><i class=\"ti ti-arrow-left\"></i></div><div class=\"controller-icon next\"><i class=\"ti ti-arrow-right\"></i></div></div>", 1)),
          (_ctx.c.reviews_url)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("a", {
                  href: _ctx.c.reviews_url,
                  target: "_blank",
                  rel: "noopener",
                  class: "btn"
                }, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.c.reviews_label || 'Read all our reviews'), 1)
                ], 8, _hoisted_15)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 4)
    ])
  ]))
}